export default class SearchFiltersElement extends HTMLElement {
  constructor() {
    super();
  }
}
customElements.define('search-filters', SearchFiltersElement);